import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem, Chip } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_CATALOG_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faFilter, faMicroscope, faPlus, faRefresh, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DataGrid } from "@mui/x-data-grid"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { Box, Drawer } from "@mui/material"
import debounce from 'lodash.debounce';
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/catalogEntrySlice"
import { calculateTotal } from "../../Utility/utility"
import { useModalToast } from "../../components/modalToast/ModalToastContext"
import InputWithSuggestions from "../../components/InputWithSuggestions"

const RowsField = {
    id: "id",
    detailId: "detailId",
    transId: "transId",
    itemName: "itemName",
    itemCode: "itemCode",
    pcs: "pcs",
    oldPcs: "oldPcs",
    //personName: "personName",
    remark: "remark"
}
export const InputCell = ({
    row,
    input_id,
    input_type,
    is_readonly,
    holder_text,
    is_required,
    variant,
    color,
    handleInputChange,
    handleKeyDown,
    hanldeBlur,

}) => {
    const [localValue, setLocalValue] = useState(row[input_id] ?? "");

    useEffect(() => {

        setLocalValue(row[input_id] ?? "");
    }, [row[input_id]]);

    // const onBlur = (e) => {
    //     if (localValue !== row[input_id]) {
    //         handleInputChange(row.id, { target: { value: localValue, id: RowsField[input_id] } });
    //     }

    //     hanldeBlur(row.id, e);



    // };
    // const handleChange = (e) => {
    //     const { id, value } = e.target
    //     let isValid = true
    //     if ([RowsField.denier, RowsField.fedNo, RowsField.perMtrWeight, RowsField.wastagePer, RowsField.wastageWeight, RowsField.totalWeight, RowsField.totalPick, RowsField.ends].includes(id))
    //         isValid = funValidateNoInput(value)
    //     if (isValid)
    //         setLocalValue(value)

    // }
    const onBlur = (e) => {
        const syntheticEvent = {
            ...e,
            target: {
                ...e.target,
                value: localValue,
                id: RowsField[input_id],
            },
        };

        handleInputChange(
            row.id,
            syntheticEvent,
            RowsField[input_id]
        );

        setTimeout(() => {
            hanldeBlur(
                row.id,
                syntheticEvent,
                RowsField[input_id]
            );
        }, 0);
    };
    return (
        <input
            required={is_required}
            id={RowsField[input_id]}
            type={input_type}
            readOnly={is_readonly}
            placeholder={holder_text}
            value={localValue}
            // onKeyDown={(e) => handleKeyDown(row.id, e)}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={onBlur}
            onFocus={(e) => e.target.select()}
            className={`
    w-full mt-1 text-xs border rounded px-2 py-2
   
  `}
        />
        // <Input
        //     isRequired={is_required}
        //     id={RowsField[input_id]}
        //     type={input_type}
        //     size="sm"
        //     labelPlacement="outside"
        //     readOnly={is_readonly}
        //     placeholder={holder_text}
        //     onKeyDown={(e) => handleKeyDown(row.id, e)}
        //     value={localValue}
        //     //onChange={(e) => setLocalValue(e.target.value)}
        //     onChange={handleChange}
        //     onBlur={onBlur}
        //     className="max-w-xs mt-1"
        //     variant={variant || "bordered"}
        //     color={color || ""}
        // />
    );
};
const CreateCatalogEntry = () => {
    const { compCode, appType, startDate, endDate, isMultipleCompany } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.catalogEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const gridContainerRef = useRef();
    const [modeSettingParams, setModSettingParams] = useState()
    const [selRowIndex, setSelRowIndex] = useState(0)
    const [selBillType, setSelBillType] = useState("")
    const [entryLabel, setEntryLabel] = useState("")
    const [isReloadAcItem, setIsReloadAcItem] = useState(false)
    const { show } = useModalToast();
    const { itype } = useParams();
    const formField = {
        chalNo: "chalNo",
        chalDate: "chalDate",
        transId: "transId",
        fromlocId: "fromLocId",
        toLocId: "toLocId",
        personName: "personName",
        courierId: "courierId",
        courierDocNo: "courierDocNo",
    }
    const [rows, setRows] = useState([])

    // const { isError: isErrorModSet, isPending: isPendingMod, data: modSetting = [], mutate: funModSetting } = usePost({
    //     url: apiRoute.modeSetting.getModSetting,
    //     queryKey: "fetchModSetting",
    //     onSuccessTasks: (data) => {

    //     }
    // })
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.catalogEntry.generateVoucherNo,
        queryKey: "generate-vouno",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {

                setFormData((prevData) => ({
                    ...prevData,
                    chalNo: data[0].new_vou_no,
                }))
            }
        }
    })



    const { isError: isErrorMast, isPending: isLoading, data: masterData = [], mutate: getMasterData } = usePost({
        url: apiRoute.catalogEntry.entryMasterData,
        queryKey: "getMasterData",

    })
    const { data: stockData = [], mutate: funGetStock } = usePostMutateWithSuccess({
        url: apiRoute.catalogEntry.getItemStock,
        queryKey: "getItemStcokData",

    })
    const { data: personData = [], mutate: funGetPerList } = usePostMutateWithSuccess({
        url: apiRoute.catalogEntry.getPersonList,
        queryKey: "getPersonList",

    })

    useEffect(() => {

        const params = [ENUM_CATALOG_ENTRY_TYPE.Inward, ENUM_CATALOG_ENTRY_TYPE.Outward]
        if (!params.includes(String(itype)))
            navigate(linksUrl.dashboard.tradingDashboard)

        if (itype && itype != "" && itype != null) {
            let t_billType = ""
            if (itype == ENUM_CATALOG_ENTRY_TYPE.Inward) {
                t_billType = "I"
                setEntryLabel("Inward")
            }
            if (itype == ENUM_CATALOG_ENTRY_TYPE.Outward) {
                t_billType = "O"
                setEntryLabel("Outward")
            }
            setSelBillType(t_billType)
            if (t_billType != "" && isNewEntry) {

                generateVouNo({
                    data: {
                        comp_code: compCode.join(","),
                        vou_type: t_billType,
                        start_date: dayjs(startDate).format("YYYY-MM-DD"),
                        end_date: dayjs(endDate).format("YYYY-MM-DD"),
                    }
                })
            }

        }


    }, [itype])
    const getRedirectUrl = () => {
        if (itype == ENUM_CATALOG_ENTRY_TYPE.Inward)
            return linksUrl.catalogEntry.inward.catalogEntryMaster + "/" + itype
        else if (itype == ENUM_CATALOG_ENTRY_TYPE.Outward)
            return linksUrl.catalogEntry.outward.catalogEntryMaster + "/" + itype
        else
            return ""
    }

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        if (startDate && startDate != "" && startDate != null && endDate && endDate != "" && endDate != null) {
            getMasterData({
                data: {
                    compcode: compCode.join(",")
                }
            })
        }
    }, [startDate, endDate])
    const handleNewAcItemEntry = (type) => {
        if (type == "Ac") {
            setIsReloadAcItem(true)
            window.open(linksUrl.catalogEntry.accMast.createAccEntry, "_blank");
        }
        if (type == "Item") {
            setIsReloadAcItem(true)
            window.open(linksUrl.catalogEntry.itemMast.createProductEntry, "_blank");
        }
    }
    const handleReloadAcItemEntry = (type) => {
        getMasterData({
            data: {
                compcode: compCode.join(",")
            }
        })
    }

    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.catalogEntry.add_update,
        queryKey: "funAddUpdateCatalog",
        onSuccessTasks: (data) => {
            dispatch(resetDetailParams())
            navigate(getRedirectUrl())
            toast.success(`Items ${isNewEntry ? " Added" : " Updated"}`, {
                position: "top-center"
            })
            //navigate(linksUrl.masterItemEntry.masterItemEntryMaster);
        }
    })



    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePostMutateWithSuccess({
        url: apiRoute.catalogEntry.fetchEntryDetail,
        queryKey: "fetchCatalogDetail",
    });



    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { bill_type, transactionid, comp_code } = detailParams
            funGetDetail({
                data: {
                    comp_code: comp_code,
                    bill_type: bill_type,
                    trans_id: transactionid
                },

            })
        }
    }, [])


    const [deletedItemRows, setDeletedItemRows] = useState([])



    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.pcs]: "",
        [RowsField.oldPcs]: 0,
        [RowsField.remark]: "",
        //  [RowsField.personName]: ""
    }


    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == "chalDate")
            acc[key] = new Date()
        else if (key == "transId")
            acc[key] = 0
        else
            acc[key] = ""
        return acc
    }, {})


    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {
        Row1: [
            {
                id: formField.chalNo,
                name: formField.chalNo,
                placeholder: "Chal No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.chalDate,
                name: formField.chalDate,
                placeholder: "Chal Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            }],
        Row2: [
            {
                id: formField.fromlocId,
                name: formField.fromlocId,
                placeholder: "From Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.fromLocMaster ? masterData?.fromLocMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,

            },
            {

                id: formField.toLocId,
                name: formField.toLocId,
                placeholder: "To Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.toLocMaster ? masterData?.toLocMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,


            }
        ],
        Row3: [
            {
                id: formField.courierId,
                name: formField.courierId,
                placeholder: "Courier",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.courierMaster ? masterData?.courierMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,

            },
            {
                id: formField.courierDocNo,
                name: formField.courierDocNo,
                placeholder: "Courier Doc No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        // Row4: [
        //     {
        //         id: formField.personName,
        //         name: formField.personName,
        //         placeholder: "Person Name",
        //         type: ENUM_INPUT_TYPE.text,
        //         size: "sm",
        //         label: "",
        //         isrequired: false,
        //     },
        // ]



    }

    //     const handleInputChange = (rowId, e,name) => {
    //         const { value, id } = e.target;
    //         //const { value, id } = e.target;
    // console.log(value,id,name,rowId,rows)
    //         if (selBillType === 'O' && id === "pcs") {
    //             const index = rows.findIndex((ele) => ele.id == rowId);

    //             if (index === -1 || rows[index].itemCode === '') {
    //                 show("first Select Item");
    //                 return;
    //             }

    //             const enteredValue = Number(value);
    //             if (enteredValue <= 0) {
    //                 show("No Of Catalog Should Be Greater Than  0");
    //                 return;
    //             }

    //             funGetStock({
    //                 data: { itemCode: rows[index].itemCode },
    //                 onSuccess: (data) => {
    //                     if (data && data.length > 0) {

    //                         const oldPcs = Number(rows[index].oldPcs || 0);
    //                         const StockPcs = Number(data[0].StockPcs) + oldPcs;

    //                         if (StockPcs < enteredValue) {

    //                             setRows(prev =>
    //                                 prev.map(row =>
    //                                     row.id == rowId
    //                                         ? { ...row, pcs: "" }
    //                                         : row
    //                                 )
    //                             );

    //                             show(<div><div className='bg-yellow-50 p-2 text-yellow-500 font-semibold '>Total Stock of Item {rows[index].itemName} is  {StockPcs}  Pcs</div>
    //                                 <h2 className="p-3">You can not add pcs greater than {StockPcs}</h2></div>);




    //                             return;
    //                         }
    //                         else {

    //                             setRows((prevData) => {
    //                                 const index = prevData.findIndex((row) => row.id === rowId);
    //                                 if (index === -1) return prevData;

    //                                 const updatedRow = {
    //                                     ...prevData[index],
    //                                     [id]: value,
    //                                 };


    //                                 const newData = [...prevData];
    //                                 newData[index] = updatedRow;
    //                                 return newData;
    //                             });
    //                         }
    //                     }
    //                 }
    //             });
    //         }
    //         else {

    //             setRows((prevData) => {
    //                 const index = prevData.findIndex((row) => row.id === rowId);
    //                 if (index === -1) return prevData;

    //                 const updatedRow = {
    //                     ...prevData[index],
    //                     [id]: value,
    //                 };


    //                 const newData = [...prevData];
    //                 newData[index] = updatedRow;
    //                 return newData;
    //             });
    //         }

    //     };


    const handleInputChange = (rowId, e) => {
        const { value, id } = e.target;

        // Allow clearing input
        if (value === "") {
            setRows((prevData) => {
                const index = prevData.findIndex(
                    (row) => row.id === rowId
                );

                if (index === -1) return prevData;

                const newData = [...prevData];

                newData[index] = {
                    ...newData[index],
                    [id]: "",
                };

                return newData;
            });

            return;
        }

        setRows((prevData) => {
            const index = prevData.findIndex(
                (row) => row.id === rowId
            );

            if (index === -1) return prevData;

            const newData = [...prevData];

            newData[index] = {
                ...newData[index],
                [id]: value,
            };

            return newData;
        });
    };

    const handleBlur = (rowId, e) => {
        const { value, id } = e.target;

        if (id === RowsField.pcs && selBillType === "O") {
            const index = rows.findIndex(
                (ele) => ele.id === rowId
            );

            if (
                index === -1 ||
                rows[index].itemCode === ""
            ) {
                show("First Select Item");
                return;
            }

            if (value === "") return;

            const enteredValue = Number(value);

            if (enteredValue <= 0) {
                show(
                    "No Of Catalog Should Be Greater Than 0"
                );

                setRows((prev) =>
                    prev.map((row) =>
                        row.id === rowId
                            ? { ...row, pcs: "" }
                            : row
                    )
                );

                return;
            }

            funGetStock({
                data: {
                    itemCode: rows[index].itemCode,
                },
                onSuccess: (data) => {
                    if (
                        data &&
                        data.length > 0
                    ) {
                        const oldPcs = Number(
                            rows[index].oldPcs || 0
                        );

                        const StockPcs =
                            Number(data[0].StockPcs) +
                            oldPcs;

                        if (
                            enteredValue > StockPcs
                        ) {
                            setRows((prev) =>
                                prev.map((row) =>
                                    row.id === rowId
                                        ? {
                                            ...row,
                                            pcs: "",
                                        }
                                        : row
                                )
                            );

                            show(
                                <div>
                                    <div className="bg-yellow-50 p-2 text-yellow-500 font-semibold">
                                        Total Stock of Item{" "}
                                        {
                                            rows[index]
                                                .itemName
                                        }{" "}
                                        is {StockPcs} Pcs
                                    </div>

                                    <h2 className="p-3">
                                        You can not add
                                        pcs greater than{" "}
                                        {StockPcs}
                                    </h2>
                                </div>
                            );

                            return;
                        }
                    }
                },
            });
        }

        // Auto add row when leaving Remark field of last row
        funGridSetting(value, id, rowId);

        if (isMobile) {
            setSelRowIndex(rowId);
        }
    };
    const funGridSetting = (value, id, rowId) => {
        if (id !== RowsField.remark) return;

        const rowIndex = rows.findIndex(
            (row) => row.id === rowId
        );

        // If current row is the last row, add a new one
        if (rowIndex === rows.length - 1) {
            funGenGridRows();
        }
    };
    // const funGridSetting = (value, id, index) => {

    //     let rowId = RowsField.remark
    //     if (id == rowId) {
    //         let lastRow = rows.length
    //         if (index == lastRow) {
    //             funGenGridRows(1);
    //         }
    //     }
    // }

    const handleKeyDown = (rowid, event) => {
        console.log("hi")
        setSelRowIndex(rowid)
        if (event.key === 'Tab') {
            const { value, id } = event.target
            funGridSetting(value, id, rowid)


        }
        else {
            if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                return; // Do nothinghanldeBlur
            } else {
                event.stopPropagation(); // Prevent other keys from propagating
            }
        }
    };



    // const handleBluraa = (rowid, e) => {
    //     const { value, id } = e.target;

    //     if (selBillType === 'O' && id === "pcs") {
    //         const index = rows.findIndex((ele) => ele.id == rowid);

    //         if (index === -1 || rows[index].itemCode === '') {
    //             show("first Select Item");
    //             return;
    //         }

    //         const enteredValue = Number(value);
    //         if (enteredValue <= 0) {
    //             show("No Of Catalog Should Be Greater Than  0");
    //             return;
    //         }

    //         funGetStock({
    //             data: { itemCode: rows[index].itemCode },
    //             onSuccess: (data) => {
    //                 if (data && data.length > 0) {

    //                     const oldPcs = Number(rows[index].oldPcs || 0);
    //                     const StockPcs = Number(data[0].StockPcs) + oldPcs;

    //                     if (StockPcs < enteredValue) {
    //                         setRows(prev =>
    //                             prev.map(row =>
    //                                 row.id == rowid
    //                                     ? { ...row, pcs: "" }
    //                                     : row
    //                             )
    //                         );

    //                         show(<div><div className='bg-yellow-50 p-2 text-yellow-500 font-semibold '>Total Stock of Item {rows[index].itemName} is  {StockPcs}  Pcs</div>
    //                             <h2 className="p-3">You can not add pcs greater than {StockPcs}</h2></div>);




    //                         return;
    //                     }
    //                 }
    //             }
    //         });
    //     }

    //     if (isMobile) {
    //         setSelRowIndex(rowid);
    //         funGridSetting(value, id, rowid);
    //     }
    // };


    const itemGridHeadClass = "bill-grid-simple"

    const columns = [
        {
            field: RowsField.id,
            headerName: "No.",
            width: 30,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <div className="flex gap-2 font-semibold">
                    {row.id}
                    <strong>

                        <FontAwesomeIcon
                            color="red"
                            className="cursor-pointer text-md"
                            onClick={() => handleDeleteRow(row.id, "")}
                            icon={faSquareXmark}

                        ></FontAwesomeIcon>
                    </strong>
                </div>
            ),
        },

        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.itemCode}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"

                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={handleBlur}
                />
            //renderInputCell(row, RowsField.itemCode, "text", true, "", false, "", ""),

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 200,
            //isVisible:true,
            headerAlign: "center",
            flex: 1,
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <Autocomplete
                    isRequired
                    size="sm"
                    id={RowsField.itemName}
                    eventResizeFeature={true}
                    selectionMode="single"
                    showScrollIndicators={true}
                    placeholder="--Select--"
                    className="max-w-23"
                    isLoading={isLoading}
                    isClearable={false}
                    readOnly={false}
                    isVirtualized
                    value={row.itemName}
                    menuTrigger={"input"}
                    defaultItems={
                        masterData && masterData.itemMaster ? masterData?.itemMaster : []
                    }
                    onSelectionChange={(e) =>
                        handleAutoCompleteChange(e, row.id, RowsField.itemName)
                    }
                    selectedKey={row.itemCode}
                    color={"success"}
                    variant="flat"
                >
                    {(item) => (
                        <AutocompleteItem
                            key={item.Item_Code}
                        >
                            {item.Item_Code + "(" + item.Item_Desc + ")"}
                        </AutocompleteItem>
                    )}
                </Autocomplete>


            ),
        },
        {
            field: RowsField.pcs,
            headerName: "No. of Catalog",
            minWidth: 110,
            // flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.pcs}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={handleBlur}
                />
            //renderInputCell(row, RowsField.takaNo, "text", false, "", true, "", ""),
        },
        {
            field: RowsField.remark,
            headerName: "Remark",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.remark}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={handleBlur}
                />
            //renderInputCell(row, RowsField.takaNo, "text", false, "", true, "", ""),
        },


    ]

    const handleChange = (e) => {
        const { name, value } = e.target


        setFormData({ ...formData, [name]: value })
    }
console.log(rows)
    const handleAutoCompleteChange = (value, rowid, name) => {
        if ([formField.fromlocId, formField.toLocId, formField.courierId].includes(name)) {
            if (name == formField.toLocId && selBillType == 'O') {
                funGetPerList({
                    data: {
                        compcode: compCode.join(","),
                        party: value
                    }
                })
                setFormData({ ...formData, [name]: value, personName: "" })
            }
            else
                setFormData({ ...formData, [name]: value })
        }
        else {
            const index = rows.findIndex((ele) => ele.id == rowid)

            if (name == RowsField.itemName) {
                if (name == RowsField.itemName && rows.find((ele) => ele.itemCode == value)) {
                    show("Item Already Added")
                    const index = rows.findIndex((ele) => ele.id == rowid)
                    let newRow = [...rows]
                    newRow[index].itemCode = ""
                    newRow[index].itemName = ""
                    setRows(newRow)
                    return;
                }
                const tempdata = masterData.itemMaster
                const itemData = tempdata.filter((ele) => ele.Item_Code == value)

                if (itemData && itemData.length > 0) {
                   
                    setRows((prevData) => {
                        const newData = [...prevData];
                        const updatedArray = { ...newData[index], [RowsField.itemCode]: value, [RowsField.itemName]: itemData[0].Item_Desc }
                        newData[index] = updatedArray;
                        return newData
                    })
                }
            }
            else {
                setRows((prevData) => {
                    const newData = [...prevData];
                    const updatedArray = { ...newData[index], [name]: value }
                    newData[index] = updatedArray;
                    return newData
                })
            }
        }

    }
    // const funGenGridRows = (no_ofrows) => {


    //     let newRowsId = rows.length + 1
    //     const newRow = {
    //         id: newRowsId, ...initialRow
    //     }
    //     setRows([...rows, newRow])
    //     setTimeout(() => {
    //         const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
    //         if (gridScroller) {
    //             gridScroller.scrollLeft = 0; // Scroll to the left
    //         }
    //     }, 250)
    //     setTimeout(() => {
    //         const firstCell = gridContainerRef.current?.querySelector(
    //             `[data-id="${newRowsId}"] [data-field="id"]`
    //         );
    //         if (firstCell) {
    //             firstCell.focus();
    //         }
    //     }, 500);

    // }
    const funGenGridRows = () => {
        const newRowsId =
            rows.length > 0
                ? Math.max(...rows.map((r) => Number(r.id))) + 1
                : 1;

        const newRow = {
            id: newRowsId,
            ...initialRow,
        };

        setRows((prev) => [...prev, newRow]);

        setTimeout(() => {
            const gridScroller =
                gridContainerRef.current?.querySelector(
                    ".MuiDataGrid-virtualScroller"
                );

            if (gridScroller) {
                gridScroller.scrollLeft = 0;
            }
        }, 250);

        setTimeout(() => {
            const firstCell =
                gridContainerRef.current?.querySelector(
                    `[data-id="${newRowsId}"] [data-field="id"]`
                );

            if (firstCell) {
                firstCell.focus();
            }
        }, 500);
    };
    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        console.log(rows, "fhfgh")
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {

                if (rows[i].itemCode == "" || rows[i].itemCode == "0") {
                    if (!msg.includes("Item"))
                        msg = msg + "  Item ,";
                    no = 1
                }
                if (rows[i].pcs == "" || rows[i].pcs == "0") {
                    if (i != rows.length - 1) {
                        if (!msg.includes("Pcs"))
                            msg = msg + " Pcs ,";
                        no = 1
                    }

                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        if (formData[formField.chalNo].trim() === "" || formData[formField.chalNo] == "0") {
            newErrors[formField.chalNo] = "Chal No is required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    // useEffect(() => {
    //     validateForm();
    // }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()


        const grid_msg = ValidateGrid();

        // const validate_form = validateForm()
        //grid_msg == "" && 
        if (grid_msg == "") {
            let rowsData = rows;
            if (rows.length > 1) {
                let last_inx = rows.length - 1
                if (
                    rows[last_inx].itemCode === "" ||
                    rows[last_inx].pcs === "" ||
                    rows[last_inx].pcs === "0"
                ) {
                    rowsData = rows.slice(0, last_inx);
                }
            }
            const total_Pcs = calculateTotal({
                data: rowsData,
                columnName: "pcs",
            })

            funAddUpdate({
                data: {
                    item_list: rowsData,
                    deleteditem_list: deletedItemRows,
                    trans_id: formData[formField.transId],
                    comp_code: compCode.join(","),
                    chal_no: formData[formField.chalNo],
                    chal_date: formData[formField.chalDate],
                    from_loc: formData[formField.fromlocId],
                    to_loc: formData[formField.toLocId],
                    person_name: formData[formField.personName],
                    courier_id: formData[formField.courierId],
                    courier_docno: formData[formField.courierDocNo],
                    bill_type: selBillType,
                    pcs: total_Pcs,
                    login_userid: user.username,
                    rec_status: !isNewEntry ? 1 : 2,
                }
            })
        }
        else {
            toast.error(grid_msg, {
                "position": "top-center"
            })
        }

    }

    const handleDeleteRow = (id) => {
        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        setRows(updatedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])

    }



    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            if (detail && Object.keys(detail).length > 0) {


                const rowsData = detail?.itemDetail?.map((item, i) => {
                    return {
                        id: ++i,
                        [RowsField.detailId]: item?.DetailId ?? 0,
                        [RowsField.itemCode]: item?.Item_Code ?? "",
                        [RowsField.pcs]: item?.Nos ?? 0,
                        [RowsField.oldPcs]: item?.Nos ?? 0,
                        [RowsField.remark]: item?.Remark ?? ""
                    }
                })
                setRows(rowsData)
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId || 0,
                    [formField.chalNo]: String(detail?.itemData[0]?.Chal_No) || "",
                    [formField.chalDate]: detail?.itemData[0]?.Chal_Date || "",
                    [formField.fromlocId]: detail?.itemData[0]?.Lac_Id || "",
                    [formField.toLocId]: detail?.itemData[0]?.Pac_Id || "",
                    [formField.personName]: detail?.itemData[0]?.PersonName || "",
                    [formField.courierId]: detail?.itemData[0]?.Tac_Id || "",
                    [formField.courierDocNo]: detail?.itemData[0]?.Lr_No || "",
                })
            }

        }

    }, [detail])


    const handleClickPrev = () => {
        navigate(getRedirectUrl())
    }
    const handleAddRow = () => {
        funGenGridRows(1);
    }

    if (isError || isErrorDetail || isErrorMast) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} Catalog ${entryLabel} Entry `}
                breadcrumbs={["Product Catalog", `Catalog ${entryLabel} Entry`]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >

                <div shadow="sm" className="mb-3 w-full">
                    {/* <Test /> */}
                    {/* {itemSettings && Object.keys(itemSettings).length > 0 ? */}

                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {
                            Object.keys(inputBoxes).map((key, ind) => key == "Row3" && selBillType == "I" ? "" : (
                                <div key={key + ind}>
                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <>

                                                        <Autocomplete
                                                            size="md"
                                                            name={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            label={item?.placeholder}
                                                            eventResizeFeature={true}
                                                            selectionMode="single"
                                                            showScrollIndicators={true}
                                                            labelPlacement={"outside"}
                                                            placeholder={item.placeholder}
                                                            menuTrigger="input"
                                                            isRequired={item.isrequired}
                                                            isLoading={isLoading}
                                                            className="max-w-23  text-xs font-bold text-slate-900"
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            isClearable={false}
                                                            isVirtualized
                                                            // isReadOnly={isNewEntry ? false : true}
                                                            defaultItems={
                                                                item.data ? item.data : []
                                                            }
                                                            onSelectionChange={(e) =>
                                                                handleAutoCompleteChange(e, "", item.name)
                                                            }
                                                            color={item.id == formField.grayItemCode ? "danger" : item.id == formField.partyId ? "primary" : ""}
                                                            //onChange={handleFormSelectionChange}
                                                            selectedKey={formData[item.name]}
                                                        >
                                                            {(list) => (
                                                                <AutocompleteItem

                                                                    key={list[item.itemkey]}
                                                                >
                                                                    {list[item.itemvalue]}
                                                                </AutocompleteItem>
                                                            )}
                                                        </Autocomplete>
                                                        {/* {item.name == formField.fromlocId ?
                                                            <Chip className="cursor-pointer bg-orange-300" color={"default"} onClick={handleNewAcEntry}>
                                                                <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
                                                            </Chip>
                                                            : ""} */}

                                                    </>

                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name])
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => {
                                                                    setFormData((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            [item.name]:
                                                                                dayjs(newValue).format("YYYY-MM-DD"),

                                                                        };
                                                                    });
                                                                }}
                                                                //isRequired={item.required}
                                                                className="w-full font-semibold"
                                                                slotProps={{
                                                                    textField: { size: "small", required: true },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : (
                                                    <>

                                                        <div className="w-full">
                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                //aria-label={item.placeholder}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                //disabled={isNewEntry ? false : true}
                                                                onChange={(e) => handleChange(e)}
                                                                onBlur={(e) => handleBlur("", e)}
                                                                isReadOnly={item.name == formField.chalNo ? true : false}
                                                                //  readOnly={item.name == formField.voucherNo ? true : false}
                                                                size={"md"}

                                                                classNames={{
                                                                    label: "text-sm font-semibold",
                                                                }}
                                                            ></Input>
                                                        </div>

                                                    </>
                                                )
                                            )
                                        }
                                    </div>

                                </div>

                            ))
                        }
                        {selBillType == 'O' ?
                            <div className={` ${isMobile ? 'flex-wrap' : ''}  flex gap-4 align-top items-baseline mb-2 `}>
                                <div className="w-full">
                                    <h2 className="font-semibold text-sm mb-2">Person Name:</h2>
                                    <InputWithSuggestions
                                        label="Person Name"
                                        value={formData.personName}
                                        options={personData || []}
                                        optionKey="PersonName"
                                        onChange={(val) =>
                                            setFormData(prev => ({ ...prev, personName: val }))
                                        }
                                        onSelect={(item) => {
                                            console.log("Selected:", item);
                                        }}
                                        onCreate={(newName) => {
                                            console.log("Create new person:", newName);
                                            // call API here if needed
                                        }}
                                    />
                                </div>

                                <div className=" flex items-center w-full justify-end  gap-4">
                                    <Chip onClick={() => handleNewAcItemEntry("Ac")} className="px-0 cursor-pointer py-1 bg-green-600 text-white rounded text-xs" ><FontAwesomeIcon className="bg-white text-green-700" icon={faPlus} /> New Account</Chip>
                                    <Chip onClick={() => handleReloadAcItemEntry("Ac")} className="px-0 cursor-pointer py-1 bg-red-600 text-white rounded text-xs" ><FontAwesomeIcon className=" font-bold " icon={faRefresh} /> Account/Item</Chip>
                                    <Chip onClick={() => handleNewAcItemEntry("Item")} className="px-0  cursor-pointer py-1 bg-sky-600 text-white rounded text-xs"><FontAwesomeIcon className="bg-white text-sky-700" icon={faPlus} /> New Item</Chip>
                                </div>
                            </div> : ""}
                        <div className="mt-5">
                            <div>
                                <Button size="sm" color="success" className="text-white  font-semibold uppercase" startContent={<FontAwesomeIcon color="white" icon={faPlus} />}
                                    variant="shadow" onPress={handleAddRow}>
                                    Catalog
                                </Button>
                            </div>
                            {rows && rows?.length > 0 ? (
                                <div>
                                    <Box ref={gridContainerRef} sx={{
                                        overflow: "scroll",
                                        height: rows.length > 5 ? 300 : "auto", width: '100%',
                                    }}>
                                        {/* style={{ height: 50+ Number(rows.length * 51), width: "100%", maxHeight: "500px", overflow: "auto" }}> */}
                                        <DataGrid
                                            // ref={gridContainerRef}
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            hideFooterPagination={rows && rows.length > 100 ? false : true}
                                            hideFooter={rows && rows.length > 100 ? false : true}
                                            columnHeaderHeight={40}
                                            disableColumnMenu={false}
                                            rowHeight={45}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    fontWeight: "bold",
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .MuiDataGrid-menuIcon': {
                                                    visibility: 'visible',
                                                    opacity: 1,
                                                    width: 'auto',
                                                },
                                                // '& .MuiDataGrid-menuIcon button': {

                                                //     backgroundColor: "#ffffff",
                                                // },
                                                '& .MuiDataGrid-menuIcon svg': {
                                                    color: '#fffcfcff',

                                                },
                                                "& .MuiDataGrid-columnHeaderTitle": {
                                                    whiteSpace: "normal",
                                                    lineHeight: "1.5",
                                                    textAlign: "center",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                },
                                                "& .MuiDataGrid-columnHeader": {
                                                    height: "auto !important",
                                                },
                                                "& .MuiDataGrid-columnHeaders": {
                                                    maxHeight: "none !important",
                                                },

                                            }}
                                            disableColumnSorting={true}
                                        />
                                    </Box>

                                </div>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="justify-center flex gap-5 mt-5">
                            <Button
                                color="primary"
                                type="submit"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit
                            </Button>
                            <Button
                                color="danger"
                                variant="shadow"
                                size="sm"
                                onPress={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>

                </div>
            </MainContainer>
        </div>
    )

}
export default CreateCatalogEntry